/**
 * 表格默认配置
 */
export default {
  pk: 'id',
  // 数据主键字段
  contextPath: '',
  // 根路径
  url: '',
  // 请求表格数据的后台接口, url和pagePath二选一必填
  pagePath: '',
  // 请求表单数据页面地址, url和pagePath二选一必填
  action: '',
  // emap动作名
  datamodel: null,
  // 一般为emap返回的数据模型,
  beforeSend: null,
  // 请求发送前的回调函数
  defaultParams: false,
  // 查询请求默认附加参数
  onceParams: false,
  // 查询请求默认附加参数
  customOptions: null,
  // 初始化表单的options，允许干预
  labelPosition: 'right',
  // 标签位置
  labelWidth: '100',
  // 标签宽度
  // incrementalSearch: false, // @deprecated
  alwaysHide: ['WID', 'TBRQ', 'TBLX', 'CZRQ', 'CZZ', 'CZZXM'],
  // 自定义显示列的隐藏字段
  // fastRender: false, // @deprecated 快速渲染， 用于提高表格渲染速度
  isEditMode: false // 是否为编辑模式

};